import { HttpClient } from "@angular/common/http";
import { Injectable, forwardRef, inject } from "@angular/core";
import { CreateProduct, UpdateProduct } from "../interfaces/product.interface";
import { Observable } from "rxjs";
import { Product } from "../interfaces/product.interface";
import { API_URL } from "@equine-ui-nx/injection-tokens";

@Injectable()
export class ProductService {
  apiUrl = inject(forwardRef(() => API_URL));
  baseUrl = `${this.apiUrl}/products`
  http = inject(HttpClient);

  create(payload: CreateProduct): Observable<{id: string}> {
    return this.http.post<{id: string}>(this.baseUrl, payload);
  }

  update(id: string, payload: UpdateProduct): Observable<any> {
    return this.http.post(`${this.baseUrl}/update/${id}`, payload);
  }

  delete(id: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/delete/${id}`, {});
  }

  getAll(): Observable<Product[]> {
    return this.http.get<Product[]>(`${this.baseUrl}`);
  }
}